module.exports = new __parcel__URL__("Entrance.ede7c3ce.hdr").toString();